export interface Holding {
  readonly symbol: 'USDC' | 'BTC' | 'ETH'
  readonly name: string
  readonly amount: string
  readonly valueUsd: number
  readonly priceUsd: number
  readonly change: number
  readonly network: string
}

export const HOLDINGS: readonly Holding[] = [
  { symbol: 'USDC', name: 'USD Coin', amount: '4,120.00', valueUsd: 4120, priceUsd: 1, change: 0.0001, network: 'Base · Solana' },
  { symbol: 'BTC', name: 'Bitcoin', amount: '0.0412', valueUsd: 2811.49, priceUsd: 68240, change: 0.0212, network: 'Bitcoin' },
  { symbol: 'ETH', name: 'Ethereum', amount: '0.9120', valueUsd: 3395.39, priceUsd: 3723.02, change: -0.0087, network: 'Base' },
]
